import { render, staticRenderFns } from "./CandidateItemExamHistory.vue?vue&type=template&id=8ac467ee&lang=pug&"
import script from "./CandidateItemExamHistory.vue?vue&type=script&lang=js&"
export * from "./CandidateItemExamHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports